function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.3,47C37.1,47 46.6,37.5 46.6,25.7C46.6,13.9 37.1,4.4 25.3,4.4C13.5,4.4 4,13.9 4,25.7C4,37.5 13.5,47 25.3,47",
    style: {
      fill: "rgb(240,179,34)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,23.2C38.8,22.7 38.3,22.4 37,22.5C36.3,22.6 35.8,22.8 35.4,23.2C35,23.5 34.9,23.9 34.8,24.2C34.8,24.1 34.2,21.5 34.1,21.2C34,20.8 33,17.9 32.9,17.5C32.8,17 32.4,16 32.2,15.7C32,15.1 30.7,14.9 30.5,16C30.4,15.5 30.2,14.5 29.5,14.3C28.8,14.2 28.1,14.5 28.1,15.6C27.7,15.4 26.8,15.5 26.7,16.4C26.7,16.9 26.7,17.4 26.8,17.9C26.8,18.3 26.9,18.6 26.9,18.9C26.6,18.7 25.6,18.7 25.6,19.7C25.6,19.7 25.5,21.1 25.6,22.1C25.7,22.8 25.6,23.1 25.5,23.8C25.5,24 25.2,24.9 25.1,25.1C25.1,24.9 24.8,24 24.7,23.8C24.6,23 24.5,22.8 24.6,22.1C24.7,21.1 24.6,19.7 24.6,19.7C24.6,18.7 23.6,18.6 23.3,18.9C23.3,18.6 23.4,18.3 23.4,17.9C23.4,17.4 23.5,16.9 23.5,16.4C23.4,15.5 22.5,15.4 22.1,15.6C22.1,14.5 21.4,14.2 20.7,14.3C20,14.4 19.8,15.5 19.7,16C19.5,15 18.2,15.1 18,15.7C17.9,16 17.5,17.1 17.3,17.5C17.2,18 16.2,20.9 16.1,21.2C16,21.6 15.4,24.1 15.4,24.2C15.3,23.9 15.2,23.5 14.8,23.2C14.4,22.9 13.9,22.6 13.2,22.5C11.9,22.4 11.2,22.7 11.1,23.2C11,23.6 11.2,24 11.5,24.1C11.8,24.2 12.6,24.5 13,24.7C13.4,24.9 13.4,25.1 13.4,25.4C13.5,25.7 13.7,25.9 13.8,26.3C13.9,26.7 14,27.2 14.2,28.8C14.4,30.3 16,31.9 16.2,32.4C16.3,32.6 16.4,33 16.6,34C16.9,34.9 16.8,35.4 16.8,35.4C17.1,37.3 22.8,37.9 22.9,37.1C23.5,34 24.3,34.2 24.6,32.6C24.6,32.5 24.8,32 24.8,31.8C24.8,31.9 25,32.4 25,32.6C25.3,34.2 26.1,34 26.7,37.1C26.9,37.9 32.5,37.3 32.8,35.4C32.8,35.4 32.8,34.9 33,34C33.3,33.1 33.3,32.6 33.4,32.4C33.6,31.8 35.3,30.3 35.4,28.8C35.6,27.3 35.6,26.7 35.8,26.3C35.9,25.9 36.2,25.7 36.2,25.4C36.3,25.1 36.2,24.9 36.6,24.7C37,24.5 37.7,24.1 38,24.1C38.9,24 39.2,23.6 39,23.2",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcw);
export default __webpack_public_path__ + "static/media/dcw.2e93270068404a1841d2f3f7aa4824cc.svg";
export { ForwardRef as ReactComponent };